/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import { config, is_breakpoint_up, make_url, scroll_to, translation } from "../helpers/functions";
import Swiper from "./../libs/swiper";
import axios from "axios";
import App from "./../helpers/app";

$(function () {
  let dataIf = {
    product: { rent: "najmie", lease: "leasingu", loan: "kredycie" },
    clientType: { of: "osoby fizycznej", jdg: "firmy" },
  };

  let dataIfDenominator = {
    product: { rent: "najem", lease: "leasing", loan: "kredyt" },
    clientType: { of: "osobę fizyczną", jdg: "firmę" },
  };

  // Lead
  function initLeadStickyEvent() {
    let $section = $(".lead-config-component");
    if (!$section.length) {
      return;
    }

    let $parentContainer = $(".lead-config-container");

    let $stickContainer = $section;
    let $isInitialized =
      $stickContainer.data("sticky_kit") == true ? true : false;

    if ($isInitialized) {
      $stickContainer.trigger("sticky_kit:detach");
    }

    if (is_breakpoint_up("lg")) {
      let offsetTop =
        100 +
        ($(".header-spacer").length ? $(".header-spacer").outerHeight() : 0);

      $stickContainer
        .stick_in_parent({
          offset_top: offsetTop,
          parent: $parentContainer,
          recalc_every: 1,
          inner_scrolling: true,
        })
        .on("sticky_kit:bottom", function (e) {})
        .on("sticky_kit:stick", function (e) {})
        .on("sticky_kit:unstick", function (e) {});
    }
  }

  function populatePackages() {
    let $section = $(".lead-config-component");
    $section.find(".group-packages .package-item").each(function () {
      document.dispatchEvent(
        new CustomEvent("calculation-package-value", {
          detail: {
            id: $(this).data("package-id"),
            checked:
              $(this).find('[type="hidden"]').length ||
              ($(this).find('[type="checkbox"]').length &&
                $(this).find('[type="checkbox"]').prop("checked")),
            required: $(this).hasClass("required"),
          },
        }),
      );
    });
  }

  function versionSwiperSlideToActive(version) {
    if (version.length) {
      let versionsSwiper = $(".offer-versions-component .swiper")[0].swiper;
      if (versionsSwiper) {
        let carouselIndex = versionsSwiper.activeIndex;
        let itemActiveIndex = version
          .parent()
          .prevAll()
          .filter(":visible").length;

        if (is_breakpoint_up("sm")) {
          if (carouselIndex == 0 && itemActiveIndex - carouselIndex > 1) {
            carouselIndex = 1;
          } else if (
            carouselIndex != 0 &&
            carouselIndex != itemActiveIndex - 1
          ) {
            carouselIndex = itemActiveIndex - 1;
          }
        } else {
          carouselIndex = itemActiveIndex;
        }

        versionsSwiper.slideTo(carouselIndex);
      }
    }
  }

  let $firstLoad = true;
  let $versionSwiperUpdate = false;
  let $priceRequest = null;
  let $versionRequest = null;
  let $lastCalculation = null;
  let $lastParams = {};

  function initLeadEvents() {
    function populateChanges($form, $scenario) {
      let $section = $(".lead-config-component");
      let $activeVersion = $(".offer-versions-component").find(
        '.offer-version-component[data-natcode="' +
          $section.find('[name="LeadOfferForm[code]"]').val() +
          '"]',
      );
      let financeType = $section
        .find('[name="LeadOfferForm[finance_type]"]:checked')
        .val();
      let offerType = $section
        .find('[name="LeadOfferForm[offer_type]"]:checked')
        .val();

      $section.find(".empty-group").slideUp();
      $section.find(".group-contribution.not-empty-group").slideDown();
      $section.find(".group-mileage.not-empty-group").slideDown();

      if (financeType != "rent") {
        if (offerType == "company" && financeType == "leasing") {
          $section.find(".group-repurchase").slideDown();
        } else {
          $section.find(".group-repurchase.not-empty-group").slideUp();
        }
      } else {
        $section.find(".group-repurchase.not-empty-group").slideUp();
      }

      if ($section.find(".group-packages").hasClass("empty-group")) {
        $section.find(".group-packages.not-empty-group").slideUp();
        $(".offer-packages-component").slideUp();
      } else {
        $section.find(".group-packages").slideDown();
        $(".offer-packages-component").slideDown();
      }

      let $packages = [];
      $section
        .find(".group-packages")
        .find(
          '.package-item:visible:not(.disabled) input[type="hidden"], .package-item:visible:not(.disabled) input[type="checkbox"]',
        )
        .each(function () {
          let $package = $(this).closest(".package-item");
          $packages.push(
            '<span class="include include-' +
              $package.data("package-id") +
              '">' +
              $package.data("package-name") +
              "</span>",
          );
          $(
            ".offer-packages-component .package-item.package-" +
              $package.data("package-id"),
          ).show();
        });

      let $activePackages = [];
      $section
        .find(".group-packages")
        .find(
          '.package-item:visible:not(.disabled) input[type="hidden"], .package-item:visible:not(.disabled) input[type="checkbox"]:checked',
        )
        .each(function () {
          let $package = $(this).closest(".package-item");
          $activePackages.push(
            '<span class="include include-' +
              $package.data("package-id") +
              '">' +
              $package.data("package-name") +
              "</span>",
          );
        });

      if ($packages.length) {
        $(".offer-packages-component").show();
      } else {
        $(".offer-packages-component").hide();
      }

      if ($activePackages.length) {
        $("body").find('[data-calculation-display="packages"]').show();
      } else {
        $("body").find('[data-calculation-display="packages"]').hide();
      }
      $("body")
        .find('[data-calculation="packages"]')
        .empty()
        .append($activePackages.join(" "));

      if (financeType === "loan") {
        $section.find('[data-calculation-display="rrso"]').show();
      } else {
        $section.find('[data-calculation-display="rrso"]').hide();
      }

      $("body")
        .find(".texts-finance_type")
        .html(dataIf["product"][financeType] ?? "");

      let dataIfGenitive = {
        rent: "najmu",
        leasing: "leasingu",
        loan: "kredytu",
      };
      $("body")
        .find(".texts-finance_type--genitive")
        .html(dataIfGenitive[financeType] ?? "");

      if (offerType == "company" && financeType !== "loan") {
        $("body").find(".texts-tax").html(translation("netto"));
      } else {
        $("body").find(".texts-tax").html(translation("brutto"));
      }

      if ($section.find('[name="LeadOfferForm[code]"]').val() == "custom") {
        $section.find(".custom-version-selected").slideDown();
        $section.find(".default-version-selected").slideUp();
        $section.find(".empty-version-selected").slideUp();

        $("body")
          .find(".texts-cta")
          .html(translation("formLeadButtonCustomLead"));
      } else if ($lastCalculation && !$lastCalculation.offer) {
        $section.find(".custom-version-selected").slideUp();
        $section.find(".default-version-selected").slideUp();
        $section.find(".empty-version-selected").slideDown();

        $("body").find(".texts-cta").html(translation("formLeadButtonLead"));
      } else {
        $section.find(".custom-version-selected").slideUp();
        $section.find(".default-version-selected").slideDown();
        $section.find(".empty-version-selected").slideUp();

        $("body").find(".texts-cta").html(translation("formLeadButtonLead"));
      }

      $.each(["finance_type", "offer_type", "code"], function (k, v) {
        let value = $section
          .find(
            '[type="checkbox"][name="LeadOfferForm[' +
              v +
              ']"]:checked, [type="radio"][name="LeadOfferForm[' +
              v +
              ']"]:checked, [type="hidden"][name="LeadOfferForm[' +
              v +
              ']"]',
          )
          .val();

        $("body")
          .removeClassStartsWith("config-" + v)
          .addClass("config-" + v + "-" + value);

        document.dispatchEvent(
          new CustomEvent("base-param-changed", {
            detail: {
              param: v,
              value: value,
            },
          }),
        );
      });

      $.each(
        [{ name: "contribution" }, { name: "repurchase" }],
        function (k, v) {
          if (v.name == "contribution" || v.name == "repurchase") {
            let inputs = $section.find(
              '[name^="LeadOfferForm[' + v.name + ']"]',
            );
            inputs.each(function () {
              let slider = $(this).next()[0];
              if (slider && slider.noUiSlider) {
                slider.noUiSlider.updateOptions({}, false);
              }
            });
          }
        },
      );

      if ($scenario === "before") {
        let $changed = $form.find('[name="LeadOfferForm[user_change]"]').val();
        let $input = $form.find(
          '[name^="LeadOfferForm[' + $changed + ']"]:checked',
        );

        let $section = $(".lead-config-component");
        $section
          .find(
            '[name="' +
              $input.attr("name") +
              '"][value="' +
              $input.val() +
              '"]:not(:checked)',
          )
          .not($input)
          .val($input.val())
          .click();
      }

      if ($scenario === "after") {
        if ($activeVersion.length) {
          if ($activeVersion.attr("data-promo-hidden") == "true") {
            $("body").addClass("promo-hidden");
          } else {
            $("body").removeClass("promo-hidden");
          }
        }

        populatePackages();

        let top = window.scrollY;
        scroll_to(top + 1, null, 0);
        scroll_to(top, null, 0);

        $("[data-tippy-root]").remove();
      }
    }

    let $section = $(".lead-config-component");
    if (!$section.length) {
      return;
    }

    document.addEventListener("calculation-package-init", populatePackages);

    $section.find(".price-rrso").click(function () {
      scroll_to($(".section-offer-rrso"));
    });

    $section.find(".package-hint .hint-content").click(function (e) {
      e.preventDefault();
      $(this).closest(".package-hint").hide();
    });

    $section.find("input[name]").each(function () {
      let name = $(this)
        .attr("name")
        .substring(
          $(this).attr("name").indexOf("[") + 1,
          $(this).attr("name").indexOf("]"),
        );
      let value = $(this).val();

      $(document).trigger("lead:init", [
        name,
        value,
        $(this).is('[type="checkbox"]') || $(this).is('[type="radio"]')
          ? $(this).is(":checked")
          : true,
      ]);
    });

    $(document)
      .off("change.lead")
      .on("change.lead", ".lead-config-component input[name]", function () {
        let $input = $(this);
        let $form = $input.closest("form");

        if ($form.hasClass("is-loading")) {
          return;
        }

        let name = $(this).attr("name");
        name = name.substring(name.indexOf("[") + 1, name.indexOf("]"));
        if (name) {
          $form.find('[name="LeadOfferForm[user_change]"]').val(name);
          if ($.inArray(name, ["finance_type", "offer_type", "code"]) === -1) {
            $form.find('[name="LeadOfferForm[user_param_change]"]').val(name);
          }
        }

        $(document).trigger("lead:change", [name, $(this).val()]);

        $form.submit();
      });

    $(document)
      .off("submit.lead")
      .on("submit.lead", ".lead-config-component form", function (e) {
        if ($(this).hasClass("is-lead")) {
          return;
        }

        e.preventDefault();

        if ($(this).hasClass("is-loading")) {
          return;
        }

        let $form = $(this);

        populateChanges($form, "before");

        if ($priceRequest) {
          $priceRequest.cancel();
          if ($configLoader) {
            App.loader.end($configLoader);
          }
          if ($priceLoader) {
            App.loader.end($priceLoader);
          }
        }

        if (
          $('.lead-config-component [name="LeadOfferForm[code]"]').val() ===
          "custom"
        ) {
          return;
        }

        $priceRequest = axios.CancelToken.source();

        let $configLoader = $section.find(".lead-config-form");
        App.loader.init($configLoader, "new");

        let $priceLoader = $("body").find('[data-calculation-display="price"]');
        App.loader.init($priceLoader, "new");

        axios
          .post(make_url("/model/price"), $form.serialize(), {
            cancelToken: $priceRequest.token,
          })
          .then(function (response) {
            App.loader.end($configLoader);
            App.loader.end($priceLoader);

            let $section = $(".lead-config-component");

            $.each(response.data.versions, function (k, v) {
              let thumb = $(".offer-versions-component").find(
                '.offer-version-component[data-natcode="' + v.natcode + '"]',
              );

              if (v.prices.old_raw) {
                thumb
                  .find('[data-version-calculation-display="price-old"]')
                  .show();
              } else {
                thumb
                  .find('[data-version-calculation-display="price-old"]')
                  .hide();
              }

              if (v.prices.rrso_raw) {
                thumb.find('[data-version-calculation-display="rrso"]').show();
              } else {
                thumb.find('[data-version-calculation-display="rrso"]').hide();
              }

              thumb
                .find('[data-version-calculation="price-old"]')
                .html(v.prices.old);
              thumb
                .find('[data-version-calculation="price"]')
                .html(v.prices.price);
              thumb
                .find('[data-version-calculation="rrso"]')
                .html(v.prices.rrso);

              let notFoundTextPart = [];
              let notFoundText = "";
              let notFoundTextAfter = "";
              let notFoundTextBarPart = [];
              let notFoundTextBar = "";
              let notFoundTextBarAfter = " - przelicz";
              if (v.products.length) {
                notFoundTextBar = "Dostępne w ";
                notFoundText = "Kliknij i zmień na ";
                $.each(v.products, function (k, v) {
                  notFoundTextPart.push(dataIfDenominator["product"][v]);
                  notFoundTextBarPart.push(dataIf["product"][v]);
                });
              } else {
                notFoundTextBar = "Dostępne dla ";
                notFoundText = "Kliknij i zmień dla ";
                $.each(v.clientTypes, function (k, v) {
                  notFoundTextPart.push(dataIfDenominator["clientType"][v]);
                  notFoundTextBarPart.push(dataIf["clientType"][v]);
                });
              }
              let notFound =
                notFoundText + notFoundTextPart.join(" i ") + notFoundTextAfter;
              let notFoundBar =
                notFoundTextBar +
                notFoundTextBarPart.join(" i ") +
                notFoundTextBarAfter;

              if (v.offer) {
                thumb.find(".version-price-not-found").hide();
                thumb.find(".version-price-found").css("display", "flex");
              } else {
                thumb
                  .find(".version-price-not-found .price-not-found")
                  .data("notFoundBar", notFoundBar);
                thumb
                  .find(".version-price-not-found .price-not-found")
                  .text(notFoundBar);
                thumb.find(".version-price-not-found").css("display", "flex");
                thumb.find(".version-price-found").hide();
              }

              thumb.attr(
                "data-price",
                v.prices.price_raw > 0 ? v.prices.price_raw : 100000,
              );
              thumb
                .find(".price-icon")
                .empty()
                .append(
                  v.icon !== ""
                    ? '<i class="ic ic-icon-' + v.icon + '"></i>'
                    : "",
                );

              thumb.attr("data-promo", v.promotion);
              thumb.attr("data-promo-hidden", v.promotionHidden);
              thumb.find(".offer-sticker").show();
              if (v.promotionHidden == true) {
                thumb.find(".offer-sticker").hide();
              }
              thumb
                .removeClassStartsWith("promo-wyprzedaz-")
                .addClass(v.promotion);
              thumb
                .removeClassStartsWith("version-template-")
                .addClass("version-template-" + v.template);

              let thumbBadges = thumb.find("[data-version-badges]");
              if (v.tags.length) {
                $.each(v.tags, function (tagIndex, tag) {
                  let thumbBadge = $(
                    '<div class="tw-mb-2 tw-flex tw-items-start tag-' +
                      tag.id +
                      '">' +
                      '<div class="tw-relative tw-whitespace-nowrap">' +
                      (typeof tag.image !== "undefined" && tag.image
                        ? '<img alt="' +
                          tag.imageAlt +
                          '" src="' +
                          tag.image +
                          '" class="tag-image">'
                        : typeof tag.raw !== "undefined" && tag.raw
                          ? tag.label
                          : "<div>" + tag.label + "</div>") +
                      (typeof tag.value !== "undefined" && tag.value !== null
                        ? '<div class="tw-absolute tw-z-10 discount">' +
                          (typeof tag.raw !== "undefined" && tag.raw
                            ? tag.value
                            : tag.value + "<small> zł</small>") +
                          (typeof tag.disclaimer !== "undefined" &&
                          tag.disclaimer
                            ? "*"
                            : "") +
                          "</div>"
                        : "") +
                      "</div>" +
                      (typeof tag.disclaimer !== "undefined" && tag.disclaimer
                        ? '<div class="tw-ml-2 tw-text-[8px] tw-leading-tight tw-uppercase tw-border-l tw-border-r-0 tw-border-y-0 tw-border-solid tw-pl-2">*' +
                          tag.disclaimer +
                          "</div>"
                        : "") +
                      "</div>",
                  );
                  App.registerPlugins(thumbBadge);
                  thumbBadges.empty().prepend(thumbBadge);
                });
              }

              if (v.natcode == response.data.selected) {
                $lastCalculation = v;

                if (v.prices.old_raw) {
                  $("body")
                    .find('[data-calculation-display="price-old"]')
                    .show();
                } else {
                  $("body")
                    .find('[data-calculation-display="price-old"]')
                    .hide();
                }

                if (v.prices.electric_raw) {
                  $("body")
                    .find('[data-calculation-display="price-electric"]')
                    .show();
                } else {
                  $("body")
                    .find('[data-calculation-display="price-electric"]')
                    .hide();
                }

                if (v.prices.start_raw) {
                  $("body").find('[data-calculation-display="start"]').show();
                } else {
                  $("body").find('[data-calculation-display="start"]').hide();
                }

                if (v.prices.rrso_raw) {
                  $("body").find('[data-calculation-display="rrso"]').show();
                } else {
                  $("body").find('[data-calculation-display="rrso"]').hide();
                }

                $("body")
                  .find('[data-calculation="available-offers"]')
                  .html(notFound);
                $("body")
                  .find('[data-calculation="start"]')
                  .html(v.prices.start);
                $("body")
                  .find('[data-calculation="price-electric"]')
                  .html(v.prices.electric);
                $("body")
                  .find('[data-calculation="price-old"]')
                  .html(v.prices.old);
                $("body")
                  .find('[data-calculation="price"]')
                  .html(v.prices.price);
                $("body")
                  .find('[data-calculation="price-icon"]')
                  .empty()
                  .append(
                    v.icon !== ""
                      ? '<i class="ic ic-icon-' + v.icon + '"></i>'
                      : "",
                  );
                $("body").find('[data-calculation="rrso"]').html(v.prices.rrso);

                const structuredDataElement = document.getElementById(
                  "dynamicallyFilledStructuredData",
                );
                if (structuredDataElement) {
                  const structuredData = JSON.parse(
                    structuredDataElement.innerHTML,
                  );
                  structuredData.offers.price = v.prices.price_raw;
                  structuredDataElement.innerHTML =
                    JSON.stringify(structuredData);
                }
              }
            });

            $section.find("form").addClass("is-loading");

            let $paramsAppended = [
              "finance_type",
              "offer_type",
              "contract_period",
              "contribution",
              "repurchase",
              "packages",
              "mileage",
            ];
            $lastParams = {};
            $.address.history(false);
            $.address.autoUpdate(false);

            $.each(response.data.config, function (k, v) {
              if ($.inArray(v.name, $paramsAppended) !== -1) {
                if (v.name == "packages") {
                  let $url = [];
                  $.each(v.value, function (k2, v2) {
                    $url.push(k2);
                  });

                  $lastParams[v.name] = $url.join(",");
                } else {
                  $lastParams[v.name] = v.value;
                }
              }

              if (v.name == "offer_type") {
                $section
                  .find(".group-" + v.name + " .group-content .btn-group label")
                  .remove();
                let $active = null;

                $.each(v.options, function (k2, v2) {
                  if (typeof v2 !== "object") {
                    v2 = {
                      label: v2,
                      options: {},
                    };
                  }

                  if (typeof v2.options !== "undefined") {
                    if (typeof v2.options.disabled !== "undefined") {
                      return true;
                    }
                  }

                  let $label = $(
                    '<label class="btn ' +
                      (k2 == v.value ? "active" : "") +
                      '"><input type="radio" name="LeadOfferForm[' +
                      v.name +
                      ']" value="' +
                      k2 +
                      '" ' +
                      (k2 == v.value ? "checked" : "") +
                      ' autocomplete="off"><span>' +
                      v2.label +
                      "</span></label>",
                  );
                  $section
                    .find(".group-" + v.name + " .group-content .btn-group")
                    .append($label);

                  if (k2 == v.value) {
                    $active = v.value;
                  }
                });

                if ($active) {
                  $section
                    .find(
                      '[name^="LeadOfferForm[' +
                        v.name +
                        ']"][value="' +
                        $active +
                        '"]',
                    )
                    .click();
                }
              } else if (v.name == "finance_type") {
                $section
                  .find(
                    ".group-" + v.name + " .group-content .options-container",
                  )
                  .empty();
                let $active = null;

                $.each(v.options, function (k2, v2) {
                  if (typeof v2 !== "object") {
                    v2 = {
                      label: v2,
                      options: {},
                    };
                  }

                  if (typeof v2.options !== "undefined") {
                    if (typeof v2.options.disabled !== "undefined") {
                      return true;
                    }
                  }

                  let $label = $(
                    '<div class="default-radio-new">' +
                      '<input type="radio" id="finance_type-' +
                      k2 +
                      '" name="LeadOfferForm[' +
                      v.name +
                      ']" value="' +
                      k2 +
                      '" autoComplete="off" ' +
                      (k2 == v.value ? "checked" : "") +
                      ">" +
                      '<label for="finance_type-' +
                      k2 +
                      '"></label>' +
                      '<label for="finance_type-' +
                      k2 +
                      '">' +
                      v2.label +
                      "</label>" +
                      "</div>",
                  );
                  $section
                    .find(
                      ".group-" + v.name + " .group-content .options-container",
                    )
                    .append($label);

                  if (k2 == v.value) {
                    $active = v.value;
                  }
                });

                if ($active) {
                  $section
                    .find(
                      '[name^="LeadOfferForm[' +
                        v.name +
                        ']"][value="' +
                        $active +
                        '"]',
                    )
                    .click();
                }
              } else if (v.name == "contract_period") {
                $section
                  .find(
                    ".group-" + v.name + " .group-content .options-container",
                  )
                  .empty();
                let inputs = $section.find(
                  '[name^="LeadOfferForm[' + v.name + ']"]',
                );
                inputs.each(function () {
                  let input = $(this);
                  let slider = input.next()[0];
                  let group = input.closest(".config-group");

                  let prev, last;
                  var range = [];
                  $.each(v.options, function (k2, v2) {
                    if (typeof v2 !== "object") {
                      v2 = {
                        label: v2,
                        options: {},
                      };
                    }

                    if (typeof v2.options !== "undefined") {
                      if (typeof v2.options.disabled !== "undefined") {
                        return true;
                      }
                    }

                    if (prev) {
                      range.push([parseInt(prev), k2 - prev]);
                    }
                    prev = k2;
                    last = k2;

                    let $label = $(
                      '<label class="tw-flex tw-flex-col tw-items-center page" data-page="' +
                        k2 +
                        '">' +
                        '<div class="tw-font-medium tw-mb-2">' +
                        v2.label +
                        "</div>" +
                        '<div class="default-radio-new">' +
                        '<input type="radio" id="contract_period-' +
                        k2 +
                        '" name="contract_period-pagination" autocomplete="off" ' +
                        (k2 == v.value ? "checked" : "") +
                        ">" +
                        '<label class="!tw-mr-0" for="contract_period-' +
                        k2 +
                        '"></label>' +
                        "</div>" +
                        "</label>",
                    );
                    group
                      .find(".group-content .options-container")
                      .append($label);
                  });
                  if (prev) {
                    range.push([parseInt(prev)]);
                  }

                  if (range.length > 1) {
                    let options = { range: {} };

                    $.each(range, function (k2, v2) {
                      if (k2 == 0) {
                        options.range["min"] = v2;
                      } else if (k2 == range.length - 1) {
                        options.range["max"] = v2;
                      } else {
                        options.range[
                          Math.round((100 / (range.length - 1)) * k2) + "%"
                        ] = v2;
                      }
                    });

                    group.find(".noUi-slider").removeClass("tw-hidden");

                    slider.noUiSlider.updateOptions(options);
                    if (input.val() != v.value) {
                      slider.noUiSlider.set(v.value);
                    }
                  } else if (range.length === 1) {
                    group.find(".noUi-slider").addClass("tw-hidden");
                  }
                });
              } else if (
                v.name == "contribution" ||
                v.name == "repurchase" ||
                v.name == "mileage"
              ) {
                let inputs = $section.find(
                  '[name^="LeadOfferForm[' + v.name + ']"]',
                );
                inputs.each(function () {
                  let input = $(this);
                  let slider = input.next()[0];
                  let group = input.closest(".config-group");

                  if (typeof v.steps !== "undefined" && v.steps.length) {
                    let prev = null,
                      last = null;
                    var range = [];
                    $.each(v.steps, function (k2, v2) {
                      if (prev !== null) {
                        range.push([parseInt(prev), v2 - prev]);
                      }
                      prev = v2;
                      last = v2;
                    });
                    if (prev) {
                      range.push([parseInt(prev)]);
                    }

                    if (range.length > 1) {
                      let options = { range: {} };

                      $.each(range, function (k2, v2) {
                        if (k2 == 0) {
                          options.range["min"] = v2;
                        } else if (k2 == range.length - 1) {
                          options.range["max"] = v2;
                        } else {
                          options.range[
                            Math.round((100 / (range.length - 1)) * k2) + "%"
                          ] = v2;
                        }
                      });

                      slider.noUiSlider.updateOptions(options);
                    }

                    group.removeClass("empty-group");
                    group.addClass("not-empty-group");
                    input.removeAttr("disabled");
                  } else if (v.options) {
                    let options = { range: {} };

                    options.step = v.step ?? 500;
                    if (typeof v.options === "object") {
                      options.range = {
                        min: v.options["min"] ?? 10000,
                        max: v.options["max"] ?? 30000,
                      };
                    } else {
                      options.range = { min: 0, max: v.options };
                    }

                    if (options.range.min == options.range.max) {
                      v.disabled = true;
                      options.range.max++;
                    }

                    slider.noUiSlider.updateOptions(options);

                    group.removeClass("empty-group");
                    group.addClass("not-empty-group");
                    input.removeAttr("disabled");
                  } else if (v.options === null) {
                    group.addClass("empty-group");
                    group.removeClass("not-empty-group");
                    input.attr("disabled", true);
                  }

                  group.find(".disabled-message").remove();
                  if (typeof v.disabled !== "undefined" && v.disabled) {
                    group.find(".noUi-slider").addClass("tw-hidden");
                    group.find(".navigation").addClass("lg:tw-hidden");
                    $(slider.noUiSlider.target).attr("disabled", true);
                    if (
                      typeof v.params.disabledMessage !== "undefined" &&
                      v.params.disabledMessage
                    ) {
                      group
                        .find(".group-content")
                        .append(
                          '<span class="disabled-message tw-font-medium tw-text-sm lg:tw-text-center lg:tw-flex lg:tw-justify-center">' +
                            v.params.disabledMessage +
                            "</span>",
                        );
                    }
                  } else {
                    group.find(".noUi-slider").removeClass("tw-hidden");
                    group.find(".navigation").removeClass("lg:tw-hidden");
                    $(slider.noUiSlider.target).removeAttr("disabled");
                  }

                  if (input.val() != v.value) {
                    slider.noUiSlider.set(v.value);
                  }
                });
              } else if (v.name == "packages") {
                $section
                  .find(".group-packages")
                  .removeClassStartsWith("layout-")
                  .addClass("layout-" + (v.params.layout ?? "default"));

                if (v.options !== null) {
                  $section.find(".group-packages").removeClass("empty-group");
                  $section.find(".group-packages").addClass("not-empty-group");

                  $section
                    .find(".group-packages .package-item")
                    .attr("data-package-show", 0);

                  $.each(v.options, function (k2, v2) {
                    if (typeof v2 !== "object") {
                      v2 = {
                        label: v2,
                        options: {},
                      };
                    }

                    let inputs = $section.find(
                      '[name^="LeadOfferForm[' + v.name + "][" + k2 + ']"]',
                    );
                    if (!inputs.length) {
                      return;
                    }

                    let requiredChange = inputs.attr("type") === "hidden";

                    inputs
                      .closest(".package-item")
                      .removeClass("disabled")
                      .removeClass("active")
                      .removeClass("required")
                      .attr("data-package-show", 1);
                    inputs.attr("type", "checkbox");

                    let checked =
                      typeof v.value[k2] !== "undefined" && v.value[k2] == "1";

                    if (typeof v2.options !== "undefined") {
                      if (typeof v2.options.disabled !== "undefined") {
                        checked = false;
                        inputs.closest(".package-item").addClass("disabled");
                      }
                      if (
                        typeof v2.options.required !== "undefined" &&
                        v2.options.required
                      ) {
                        inputs
                          .closest(".package-item")
                          .addClass("active")
                          .addClass("required");
                        inputs.attr("type", "hidden");
                        requiredChange = false;
                      }
                    }

                    if (requiredChange) {
                      checked = false;
                    }
                    inputs.prop("checked", checked);
                  });

                  $section
                    .find(
                      '.group-packages .package-item[data-package-show="1"]',
                    )
                    .show();
                  $section
                    .find(
                      '.group-packages .package-item[data-package-show="0"]',
                    )
                    .hide();
                } else {
                  $section.find(".group-packages").addClass("empty-group");
                  $section
                    .find(".group-packages")
                    .removeClass("not-empty-group");
                  $section
                    .find(".group-packages .package-item")
                    .addClass("disabled");
                }
              }
            });

            $versionSwiperUpdate = true;

            if ($firstLoad) {
              let $versionItems = $(".offer-versions-component")
                .find(".swiper-slide")
                .sort(function (a, b) {
                  return $(a).find(".offer-version-component").data("price") >
                    $(b).find(".offer-version-component").data("price")
                    ? 1
                    : -1;
                });
              $(".offer-versions-component .swiper-wrapper")
                .empty()
                .append($versionItems);
              versionSwiperSlideToActive(
                $(".offer-versions-component .offer-version-component.active"),
              );

              $(window).scrollTop(0);

              $firstLoad = false;

              let $offer = config("detail");
              if ($offer) {
                dataLayer.push({
                  ecommerce: {
                    detail: {
                      actionField: { list: "listing" },
                      products: [
                        {
                          name: $offer.brand + " " + $offer.model,
                          id: $offer.idaggregate,
                          price: Math.round($lastCalculation.prices.price_raw),
                          brand: $offer.brand,
                          category: $offer.bodyType,
                        },
                      ],
                    },
                  },
                });
              }
            } else {
              $.each($lastParams, function (k, v) {
                $.address.parameter(k, v);
              });
            }

            $.address.parameter("q", "");
            $.address.update();

            $.address.autoUpdate(true);
            $.address.history(true);

            $(".lead-config-component .lead-config-form").show();
            $(".lead-config-component .lead-config-loader").hide();

            $section.find("form").removeClass("is-loading");

            populateChanges($form, "after");
          })
          .catch(function (e) {});
      });

    $section.find("form").submit();

    if ($section.hasClass("context-default")) {
      $.address.change(function (e) {
        let versions = $(".offer-versions-component").find(
          ".offer-version-component",
        );
        versions.removeClass("active");

        let code = $.address.parameter("code");
        if (!code || !versions.filter('[data-natcode="' + code + '"]').length) {
          code = $('.lead-config-component [name="LeadOfferForm[code]"]').val();
        }

        let version = versions.filter('[data-natcode="' + code + '"]');
        version.addClass("active");

        $("body").removeClassStartsWith("version-promo-");
        if (version.data("promo")) {
          $("body").addClass("version-" + version.data("promo"));
        }

        let $versionChanged = false;
        if (
          $('.lead-config-component [name="LeadOfferForm[code]"]').val() !=
            code &&
          $versionSwiperUpdate
        ) {
          $('.lead-config-component [name="LeadOfferForm[code]"]')
            .val(code)
            .change();
          $versionChanged = true;
        }

        if (!$firstLoad) {
          versionSwiperSlideToActive(version);
        }

        if ($versionChanged || $firstLoad) {
          let $loader = $(
            ".section-version-detail .loader-content .container-content",
          );
          App.loader.init($loader);

          if ($versionRequest) {
            $versionRequest.cancel();
          }

          if (code === "custom") {
            return;
          }

          $versionRequest = axios.CancelToken.source();

          axios
            .get(make_url("/model/version"), {
              params: { code: code, multisite: window.multisite },
              cancelToken: $versionRequest.token,
            })
            .then(function (response) {
              let $html = $(response.data.page.html);

              $html.filter("[data-container]").each(function () {
                var $part = $(this);
                var $id = $part.data("container");
                $(".offer-" + $id + "-container")
                  .empty()
                  .append($part);
              });

              App.loader.end($loader);

              let $version = $(
                ".offer-versions-component .offer-version-component.active",
              );

              populateChanges(null, "after");

              let dataLayer = window.dataLayer || [];
              dataLayer.push({ ecommerce: null });
              dataLayer.push({
                event: "view_item",
                ecommerce: {
                  items: {
                    item_id: $version.data("idaggregate"),
                    item_name:
                      $(".section-offer-banner .car-name .brand-name").text() +
                      " " +
                      $(".section-offer-banner .car-name .model-name").text(),
                    affiliation: "otomoto.pl",
                    coupon: "",
                    currency: "PLN",
                    discount: "0",
                    index: "",
                    item_brand: $(
                      ".section-offer-banner .car-name .brand-name",
                    ).text(),
                    item_category: $(".section-offer-banner")
                      .find(".body_type-tag .tag-label")
                      .text()
                      .trim(),
                    item_category2: $version
                      .find(".tech-spec-fuel .spec-value")
                      .text(),
                    item_category3: $version
                      .find(".tech-spec-transmissionKind .spec-value")
                      .text(),
                    item_category4: "", // liczba miejsc
                    item_category5: $version.data("promo"),
                    item_list_id: $(".lead-config-component")
                      .find(".group-finance_type .btn.active span")
                      .text()
                      .replaceAll(" ", "-")
                      .toLowerCase(),
                    item_list_name: $(".lead-config-component")
                      .find(".group-offer_type .btn.active span")
                      .text()
                      .replaceAll(" ", "-")
                      .toLowerCase(),
                    item_variant: $version.find(".version-name").text(),
                    location_id: $version.data("natcode"),
                    promotion_id: "",
                    promotion_name: "",
                    price: $version.data("price"),
                    quantity: "1",
                  },
                },
              });
              dataLayer.push({
                ecommerce: {
                  detail: {
                    actionField: { list: "listing" },
                    products: [
                      {
                        name: $offer.brand + " " + $offer.model,
                        id: $offer.idaggregate,
                        price: $lastCalculation
                          ? Math.round($lastCalculation.prices.price_raw)
                          : 0,
                        brand: $offer.brand,
                        category: $offer.bodyType,
                        variant: natcode,
                        quantity: 1,
                      },
                    ],
                  },
                },
              });
            })
            .catch(function () {});
        }
      });
    }

    if ($section.hasClass("context-default")) {
      initLeadStickyEvent();
      $(window).on("resize headerSpacer.resized", function () {
        initLeadStickyEvent();
      });
    }
  }

  initLeadEvents();

  // Versions
  function getMobileActiveVersionSlide() {
    let height = $(window).outerHeight();
    let width = $(window).outerWidth();
    let version;

    $(".offer-versions-component .offer-version-component:visible").each(
      function () {
        var rect = $(this)
          .find("[data-version-onscreen-control]")
          .get(0)
          .getBoundingClientRect();

        if (rect.left >= 0 && rect.right <= width) {
          version = $(this);
          return false;
        }
      },
    );

    return version;
  }

  function initLeadOptions() {
    $(document).on("lead-submit", function (e, context, action, natcode, el) {
      el = el ?? null;
      context =
        context ?? $('.lead-config-component [name*="[context]"]').val();
      action = action ?? "";
      natcode = natcode ?? $('.lead-config-component [name*="[code]"]').val();
      if (!context) {
        context = "default";
      }

      if (el && el.length) {
        App.loader.init(el, "new");
      }

      let $offer = config("detail");
      let $version = $(
        '.offer-version-component[data-natcode="' + natcode + '"]',
      );
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          items: [
            {
              item_id: $offer.idaggregate,
              item_name: $offer.brand + " " + $offer.model,
              affiliation: "otomoto.pl",
              coupon: $(".lead-config-component")
                .find('[name="LeadOfferForm[contribution]"]')
                .val(),
              currency: "PLN",
              discount: 0,
              index: "",
              item_brand: $offer.brand,
              item_category: $offer.bodyType,
              item_category2: $version.length
                ? $version.find(".tech-spec-fuel .spec-value").text()
                : "",
              item_category3: $version.length
                ? $version
                    .find(".tech-spec-transmissionKind .spec-value")
                    .text()
                : "",
              item_category4: "",
              item_category5: $version.length ? $version.data("promo") : "",
              item_list_id: $(".lead-config-component")
                .find(".group-finance_type .btn.active span")
                .text()
                .replaceAll(" ", "-")
                .toLowerCase(),
              item_list_name: $(".lead-config-component")
                .find(".group-offer_type .btn.active span")
                .text()
                .replaceAll(" ", "-")
                .toLowerCase(),
              item_variant: $version.length
                ? $version.find(".version-name").text()
                : "",
              location_id: natcode,
              promotion_id: "",
              promotion_name: "",
              price: $lastCalculation
                ? Math.round($lastCalculation.prices.price_raw)
                : 0,
              quantity: 1,
            },
          ],
        },
      });
      dataLayer.push({
        event: "addToCart",
        ecommerce: {
          currencyCode: "PLN",
          add: {
            products: [
              {
                name: $offer.brand + " " + $offer.model,
                id: $offer.idaggregate,
                price: $lastCalculation
                  ? Math.round($lastCalculation.prices.price_raw)
                  : 0,
                brand: $offer.brand,
                category: $offer.bodyType,
                variant: natcode,
                quantity: 1,
              },
            ],
          },
        },
      });

      $.address.history(false);
      $.address.autoUpdate(false);
      $.each($lastParams, function (k, v) {
        $.address.parameter(k, v);
      });

      let experiments = [];
      if (growthbookExperiments.length) {
        growthbookExperiments.forEach((item) =>
          experiments.push(
            "experiment_" + item.name + "__variant_" + item.variant,
          ),
        );
      }
      $('.lead-config-component [name*="[experiment]"]').val(
        experiments.join(" "),
      );
      $('.lead-config-component [name*="[lead_url]"]').val($.address.value());
      $('.lead-config-component [name*="[context]"]').val(context);
      $('.lead-config-component [name*="[cta_placement]"]').val(action);
      $('.lead-config-component [name*="[code]"]').val(natcode);
      $(".lead-config-component form")
        .data("lead", 1)
        .addClass("is-lead")
        .attr(
          "action",
          make_url(
            "/lead/init/" +
              context +
              "?device=" +
              (is_breakpoint_up("lg") ? "desktop" : "mobile"),
          ),
        );
      $(".lead-config-component form").submit();
    });

    $(document).on(
      "click",
      "[data-lead-init], [data-lead-context], [data-lead-action]",
      function (e) {
        e.preventDefault();

        $(document).trigger("lead-submit", [
          $(this).data("lead-context") ?? undefined,
          $(this).data("lead-action") ?? undefined,
          $(this).data("lead-natcode") ?? undefined,
          $(this),
        ]);
      },
    );
  }

  initLeadOptions();

  function initVersionsEvents() {
    let $section = $(".offer-versions-component");
    if (!$section.length) {
      return;
    }

    let versions = $section.find(".offer-version-component");

    $section.on("click", ".offer-version-component", function (e) {
      let version = $(this);

      if (
        $(e.target).data("lead-pdf") ||
        $(e.target).closest("[data-lead-pdf]").length
      ) {
        $.address.parameter("code", version.data("natcode"));
        $(document).trigger("lead-submit", [
          "download",
          null,
          version.data("natcode"),
          $(e.target).is("[data-lead-pdf]")
            ? $(e.target)
            : $(e.target).closest("[data-lead-pdf]"),
        ]);
        return;
      }

      if (
        $(e.target).data("lead-context") ||
        $(e.target).closest("[data-lead-context]").length
      ) {
        let $target = $(e.target).is("[data-lead-context]")
          ? $(e.target)
          : $(e.target).closest("[data-lead-context]");
        $(document).trigger("lead-submit", [
          $target.data("lead-context") ?? null,
          $target.data("lead-action") ?? null,
          $target.data("lead-natcode") ?? null,
          $target,
        ]);
        return;
      }

      if (
        (version.data("natcode") === "custom" && is_breakpoint_up("sm")) ||
        (version.data("natcode") === "custom" &&
          !is_breakpoint_up("sm") &&
          typeof e.originalEvent !== "undefined" &&
          e.originalEvent.isTrusted === true)
      ) {
        return;
      }

      if (
        (version.data("natcode") === "custom" && is_breakpoint_up("lg")) ||
        (version.data("natcode") === "custom" &&
          !is_breakpoint_up("lg") &&
          typeof e.originalEvent !== "undefined" &&
          e.originalEvent.isTrusted === true)
      ) {
        $(document).trigger("lead-submit", [
          null,
          null,
          version.data("natcode"),
        ]);
      }

      if (
        $('.lead-config-component [name="LeadOfferForm[code]"]').val() ==
        version.data("natcode")
      ) {
        return;
      }

      if (
        !is_breakpoint_up("lg") &&
        typeof e.originalEvent !== "undefined" &&
        e.originalEvent.isTrusted === true
      ) {
        // return;
      }

      $.address.autoUpdate(true);
      $.address.parameter("code", version.data("natcode"));
    });

    function onSwiperSlideChange() {
      if (!is_breakpoint_up("sm") && $versionSwiperUpdate && !$firstLoad) {
        let version = getMobileActiveVersionSlide();
        if (
          version &&
          version.length &&
          version.find(".version-price-found:visible").length
        ) {
          version.click();
        }
      }
    }

    let versionsSwiper = new Swiper(".offer-versions-component .swiper", {
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 20,
          slidesOffsetAfter: -60,
        },
        576: {
          slidesPerView: 2,
          spaceBetween: 20,
          slidesOffsetAfter: -60,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
          slidesOffsetAfter: -60,
        },
        992: {
          slidesPerView: 2,
          spaceBetween: 20,
          slidesOffsetAfter: 0,
        },
        1280: {
          slidesPerView: 3,
          spaceBetween: 20,
          slidesOffsetAfter: 0,
        },
      },
      navigation: {
        nextEl: ".version-swiper .versions-nav .next",
        prevEl: ".version-swiper .versions-nav .prev",
      },
      pagination: {
        el: ".versions-pagination",
        clickable: true,
        bulletClass: "page",
        bulletActiveClass: "active",
      },
      on: {
        sliderFirstMove: function () {
          $("[data-tippy-root]").remove();
        },
        slideChangeTransitionEnd: onSwiperSlideChange,
        reachEnd: onSwiperSlideChange,
        fromEdge: onSwiperSlideChange,
        transitionEnd: onSwiperSlideChange,
      },
    });
  }

  initVersionsEvents();
});

function initFinanceComponentMobile() {
  let $section = $(".lead-config-container");
  if (!$section.length) {
    return;
  }

  if (!is_breakpoint_up("lg")) {
    const component = $(".lead-config-component").detach();
    $(".offer-bar-finance-component").empty().append(component);
  }
}

initFinanceComponentMobile();

function initTest() {
  let $section = $(".lead-config-component");
  if (!$section.length) {
    return;
  }

  const $pdfButtons = $("[data-lead-pdf]");
  $pdfButtons.hide();

  document.addEventListener("growthbook-features-not-loaded", (e) => {
    $pdfButtons.show();
  });

  document.addEventListener("growthbook-features-loaded", (e) => {
    const isPdfDownload = growthbook.isOn("pdf-download");
    const leadAvailabilityContext = growthbook.getFeatureValue(
      "lead-availability-context",
      "default",
    );

    if (isPdfDownload) {
      $pdfButtons.show();
    }

    $("[data-lead-init]").attr("data-lead-context", leadAvailabilityContext);
  });
}

initTest();
